import React from "react";
import { Link } from "react-router-dom";

const PostList = ({ posts, visibility }) => {
  // Calculate the elapsed time for each post

  const elapsedTime = (posts) => {
    posts.forEach((post) => {
      const postDate = new Date(post.post_date);
      const currentDateTime = new Date();
      const elapsedMilliseconds =
        currentDateTime.getTime() - postDate.getTime();
      const elapsedSeconds = elapsedMilliseconds / 1000;
      let elapsed;

      if (elapsedSeconds < 60) {
        elapsed = `${Math.round(elapsedSeconds)} seconds ago`;
      } else if (elapsedSeconds < 3600) {
        elapsed = `${Math.round(elapsedSeconds / 60)} minutes ago`;
      } else if (elapsedSeconds < 86400) {
        elapsed = `${Math.round(elapsedSeconds / 3600)} hours ago`;
      } else if (elapsedSeconds < 2592000) {
        elapsed = `${Math.round(elapsedSeconds / 86400)} days ago`;
      } else if (elapsedSeconds < 31536000) {
        elapsed = `${Math.round(elapsedSeconds / 2592000)} months ago`;
      } else {
        elapsed = `${Math.round(elapsedSeconds / 31536000)} years ago`;
      }

      post.elapsed = elapsed;
    });
  };

  elapsedTime(posts);

  return (
    <div className="post">
      {posts.map((post, index) => (
        <div
          key={post.id}
          className="post-box"
          style={{ display: visibility[index] ? "block" : "none" }}
        >
          <img
            src={post.post_img}
            className="post-img"
            alt={post.post_img_alt || "Image"}
          />
          <h2 className="category">{post.post_category}</h2>
          <Link to={`/post-pages/${post.id}`} className="post-title">
            {post.post_title}
          </Link>
          <p className="post-description">{post.post_description}</p>

          <div className="profile">
            <img
              src={post.profile_img}
              className="profile-img"
              alt={post.profile_img_alt || "Profile"}
            />
            <div className="elapsed">
              <span className="profile-name">{post.profile_name}</span>
              <span className=" post-date">{post.elapsed}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostList;
